// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import {Row, Col} from "reactstrap"
import i18n from "./../i18n/i18n";
import classNames from 'classnames';

import "./FormField.scss";

function bootstrapColOffsetToStyle(obj1) {
    const res = {};

    if (obj1.xs && obj1.xs !== 12) {
        res.xsOffset = obj1.xs;
    }
    if (obj1.sm && obj1.sm !== 12) {
        res.smOffset = obj1.sm;
    }
    if (obj1.md && obj1.md !== 12) {
        res.mdOffset = obj1.md;
    }
    if (obj1.lg && obj1.lg !== 12) {
        res.lgOffset = obj1.lg;
    }
    if (obj1.xl && obj1.xl !== 12) {
        res.xlOffset = obj1.xl;
    }

    return res;
}
function bootstrapColGridAdd(obj1, obj2) {
    const res = {};

    if (obj1.xs || obj2.xs) {
        res.xs = obj1.xs + obj2.xs;
    }
    if (obj1.sm || obj2.sm) {
        res.sm = obj1.sm + obj2.sm;
    }
    if (obj1.md || obj2.md) {
        res.md = obj1.md + obj2.md;
    }
    if (obj1.lg || obj2.lg) {
        res.lg = obj1.lg + obj2.lg;
    }
    if (obj1.xl || obj2.xl) {
        res.xl = obj1.xl + obj2.xl;
    }

    return res;
}
function bootstrapColGridToStyle(obj) {
    let cls = "";
    if (typeof obj.xs !== "undefined") {
        if (obj.xs) {
            cls += ` col-xs-${obj.xs}`;
        } else {
            cls += ` hidden-xs`;
        }
    }
    if (typeof obj.xsOffset !== "undefined") {
        cls += ` col-xs-offset-${obj.xsOffset}`;
    }
    if (typeof obj.sm !== "undefined") {
        if (obj.sm) {
            cls += ` col-sm-${obj.sm}`;
        } else {
            cls += ` hidden-sm`;
        }
    }
    if (typeof obj.smOffset !== "undefined") {
        cls += ` col-sm-offset-${obj.smOffset}`;
    }
    if (typeof obj.md !== "undefined") {
        if (obj.md) {
            cls += ` col-md-${obj.md}`;
        } else {
            cls += ` hidden-md`;
        }
    }
    if (typeof obj.mdOffset !== "undefined") {
        cls += ` col-md-offset-${obj.mdOffset}`;
    }
    if (typeof obj.lg !== "undefined") {
        if (obj.lg) {
            cls += ` col-lg-${obj.lg}`;
        } else {
            cls += ` hidden-lg`;
        }
    }
    if (typeof obj.lgOffset !== "undefined") {
        cls += ` col-lg-offset-${obj.lgOffset}`;
    }
    if (typeof obj.xl !== "undefined") {
        if (obj.xl) {
            cls += ` col-xl-${obj.xl}`;
        } else {
            cls += ` hidden-xl`;
        }
    }
    if (typeof obj.xlOffset !== "undefined") {
        cls += ` col-xl-offset-${obj.xlOffset}`;
    }
    return cls;
}

class FormField extends AbstractReactComponent {
    static contextTypes = {
        fieldLabelPrefix: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
        formPath: React.PropTypes.string,
    }

    static PropTypes = {
        inputLabelOffset: React.PropTypes.bool, // pokud je uvedeno a je label na false, dá se do inpit class offset z label tak, aby byl input zarovnaný s ostatními hodnotami, které mají label, pokud je false, vezme se pro input class hodnota definovaná v noLabelInputClass
        inline: React.PropTypes.bool,
        required: React.PropTypes.bool,
        error: React.PropTypes.string,  // překrytí chyby - v případě vlastního zpracování chyb
        groupClass: React.PropTypes.object,
        labelRight: React.PropTypes.bool,   // má být label fieldu napravo od něj?
        labelInField: React.PropTypes.bool,   // má být label renderovaný až ve fieldu, bude pak předaný jako label do fieldu přes props?
        labelClass: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.object
        ]),
        inputClass: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.object
        ]),
        noLabelInputClass: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.object
        ]),
        field: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.func,
        ]),
        row: React.PropTypes.bool,
        label: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.string
        ]),
        title: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.string
        ]),
    };

    static defaultProps = {
        labelInField: false,
        groupClass: {},
        inline: false,
        labelClass: {xs: 12, sm: 4, md: 4, lg: 4, xl: 4},
        inputClass: {xs: 12, sm:8, md: 8, lg: 8, xl: 8},
        noLabelInputClass: {xs: 12, sm:12, md: 12, lg: 12, xl: 12},
    };

    render() {
        const {
            input,
            error,
            meta,
            name,
            label,
            title,
            row,
            field,
            labelClass,
            groupClass,
            inputClass,
            noLabelInputClass,
            inputLabelOffset,
            inline,
            required,
            labelRight,
            labelInField,
            ...other
        } = this.props;





        const { fieldLabelPrefix, formPath } = this.context;

        let fieldLabelText;
        const useName = name || (input ? input.name : null);
        if (fieldLabelPrefix && useName) {
            if (labelInField || label === true || title === true) {
                if (Object.prototype.toString.call(fieldLabelPrefix) === "[object Array]") {
                    const keys = fieldLabelPrefix.map(key => formPath ? key + useName.substring(formPath.length) : key + useName);
                    fieldLabelText = i18n(keys);
                } else {
                    if (formPath) {
                        fieldLabelText = i18n(fieldLabelPrefix + useName.substring(formPath.length));
                    } else {
                        fieldLabelText = i18n(fieldLabelPrefix + useName);
                    }
                }
            }
        }

        let labelComponent;
        if (label === true) {
            labelComponent = fieldLabelText ? fieldLabelText : null;
        } else if (label) {
            labelComponent = label;
        }

        let titleComponent;
        if (title === true) {
            titleComponent = fieldLabelText ? fieldLabelText : null;
        } else if (title) {
            titleComponent = title;
        }

        let errorText;
        const hasError = (meta && meta.touched && meta.error) || (error);
        if (hasError) {
            errorText = error || (meta ? meta.error : null);
        }

        if (inline && hasError) {
            titleComponent = errorText; // TODO spojit error a titulek
        }

        // ----------------------------------

        let content;

        const formGroupClass = classNames(
            'form-group',
            {
                'error': hasError,
                'required': required
            }
        );

        let labelInFieldComponent;
        if (labelInField === true) {
            labelInFieldComponent = fieldLabelText;
        } else if (labelInField) {
            labelInFieldComponent = labelInField;
        } else {
            labelInFieldComponent = null;
        }

        if (inputClass) {
            let labelPart;
            if (labelComponent) {
                labelPart = <label className={typeof labelClass == "object" ? ` ${bootstrapColGridToStyle(labelClass)}` : labelClass}>{!labelInField ? labelComponent : " "}</label>;
            }

            let inputPart = (
                <div className={bootstrapColGridToStyle(labelComponent ? inputClass : (inputLabelOffset ? {...inputClass, ...bootstrapColOffsetToStyle(labelClass)} : noLabelInputClass))}>
                    <this.props.field {...input} {...other} title={titleComponent} label={labelInFieldComponent} />
                    {!inline && hasError && <span>{errorText}</span>}
                </div>
            )

            if (labelRight) {
                content = (
                    <div className={formGroupClass}>
                        {inputPart}
                        {labelPart}
                    </div>
                )
            } else {
                content = (
                    <div className={formGroupClass}>
                        {labelPart}
                        {inputPart}
                    </div>
                )
            }
        } else {
            let labelPart;
            if (labelComponent) {
                labelPart = <label className={typeof labelClass == "object" ? ` ${bootstrapColGridToStyle(labelClass)}` : labelClass}>{!labelInField ? labelComponent : " "}</label>
            }

            if (labelRight) {
                content = <div className={formGroupClass}>
                    <this.props.field {...input} {...other} title={titleComponent} label={labelInFieldComponent} />
                    {labelPart}
                    {!inline && hasError && <span>{errorText}</span>}
                </div>;
            } else {
                content = <div className={formGroupClass}>
                    {labelPart}
                    <this.props.field {...input} {...other} title={titleComponent} label={labelInFieldComponent} />
                    {!inline && hasError && <span>{errorText}</span>}
                </div>;
            }
        }

        if (label) {
            content = <Col className={`${bootstrapColGridToStyle(groupClass)}`}>{content}</Col>
        }

        if (row) {
            return <Row>{content}</Row>;
        } else {
            return content;
        }
    }
}
export default FormField;
